import * as React from 'react';

export const Toggle: React.FC<{}> = () => {
	return <div className='Toggle'></div>;
};
